<template>
  <v-container
    fluid
    class="text-center d-flex flex-column justify-center align-center pa-8 v-sheet theme--light"
  >
    <p class="title navy-medium--text mb-6">
      Not found a quote you like?
      <broker-solution-more-quotes-text />
    </p>
    <v-btn
      x-large
      color="primary"
      class="px-8 mt-2"
      rounded
      @click="$emit('get-more-quotes')"
    >
      Get More Quotes
    </v-btn>
  </v-container>
</template>

<script>
import BrokerSolutionMoreQuotesText from '@/components/shared/BrokerSolutionMoreQuotesText.vue';

export default {
  name: 'results-additional-quotes',
  components: {
    BrokerSolutionMoreQuotesText,
  },
};
</script>
